import { getDocument } from '@atlaskit/browser-apis';

const ACTIVATION_ID_META_KEY = 'ajs-activation-id';

const getActivationIdFromMeta = (): string | null => {
	const metaTag = getDocument()?.querySelector<HTMLMetaElement>(
		`meta[name="${ACTIVATION_ID_META_KEY}"]`,
	);
	const activationId = metaTag?.getAttribute('content')?.trim();
	return activationId ? activationId : null;
};

export const useCreateKbActivationId = (_args: { cloudId: string }): string | null => {
	return getActivationIdFromMeta();
};
